import React from 'react';
import Code from './Code';

const request = `HTTP/1.1 200 OK`;

const OkResponseCode = () => <Code http={request} />;

export default OkResponseCode;
